module.exports = __webpack_public_path__ + "static/img/admin_headimg_super.2d8e133c.png";